
import {
  getApiPrefix
} from '@/utils/common'

export default {
  govConfig: '/v3/gov/insurance/govConfig',
  getConfigData: '/v3/insurance/configuration',
  getHomeData: getApiPrefix() + '/gateway',
  buyInsurance: getApiPrefix() + '/gateway'
}
